import { ChevronDown, Check } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { APPS, setAppMode } from "../lib/appMode";

export const AppSwitcher = ({ current, subtitle }) => {
  const cur = APPS.find((a) => a.id === current) || APPS[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="app-switcher-trigger" className="text-left group">
          <h1 className="font-head text-base font-extrabold tracking-tight leading-none flex items-center gap-1">
            {cur.name} <ChevronDown className="h-3.5 w-3.5 text-[#64748B] group-hover:text-[#F1F5F9] transition-colors" />
          </h1>
          {subtitle}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-72 bg-[#121724] border-[#2A364F] text-[#F1F5F9]">
        {APPS.map((a) => (
          <DropdownMenuItem key={a.id} data-testid={`app-switcher-option-${a.id}`} onSelect={() => a.id !== current && setAppMode(a.id)}
            className="flex items-start gap-2 cursor-pointer focus:bg-[#1A2032] focus:text-[#F1F5F9]">
            <Check className={`h-4 w-4 mt-0.5 ${a.id === current ? "text-[#3B82F6]" : "opacity-0"}`} />
            <div><div className="text-sm font-bold">{a.name}</div><div className="text-[11px] text-[#64748B]">{a.desc}</div></div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
